import { render, staticRenderFns } from "./ShareThis.vue?vue&type=template&id=fbed7174"
import script from "./ShareThis.vue?vue&type=script&lang=ts"
export * from "./ShareThis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports